module.exports = __webpack_public_path__ + "img/isla.246c8461.gif";